
import {getReplenishment} from '../api/getReplenishment';
import {setGetReplenishmentAction} from '../action';
import { setLoadingAction } from '../../../components/templatePage/store/action';

const setGetReplenishment = (params) => {
    return async (dispatch, getState) => {
        try {
            params.search = params.search.replace(/\s/g, '');
            const {data} = await getReplenishment(params);
    
            
            if (data.status === 'success') {
                const getArrayMap = (value) => {
                    
                    const tmp = [];
                    if (value.length) {
                        for (let i = 0; i < value.length; i++) {
                            if ((i < value.length - 1) && +value[i].event_date === +value[i + 1].event_date)  {
                                tmp.push([{...value[i]}, {...value[i + 1]}])
                                i++;
                            } else {
                                tmp.push(value[i])
                            }
                        }
                    }   
                    return tmp
                }

               

                dispatch(setGetReplenishmentAction({
                    data: getArrayMap(data.data),
                    countPage: data.countPage
                }));      
                dispatch(setLoadingAction(false))     
            }
            
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetReplenishment
}